import User from "admin/types/interfaces/user";

export const getUserInitials = (user: User) => {
  if (!user.full_name) {
    return "U";
  }
  return user.full_name.split(" ")[0][0] + user.full_name.split(" ")[1][0];
};

export const getUserNameByEmail = (email: string, users: User[]): string => {
  const user = users.find((u) => u.email === email);
  return user?.full_name || email;
};
